module.exports = __webpack_public_path__ + "fonts/caveat-v23-latin-regular.9710a79.ttf";